module.exports = __webpack_public_path__ + "static/media/bg_bridge.527378bb.png";